import WorkspaceTopbar from './WorkspaceTopbar';
import WorkspaceTopbarPreview from './WorkspaceTopbarPreview';
import WorkspaceTopbarTitle from './WorkspaceTopbarTitle';
import WorkspaceTopbarSaveButton from './WorkspaceTopbarSaveButton';

export default WorkspaceTopbar;

export { WorkspaceTopbar, WorkspaceTopbarTitle, WorkspaceTopbarSaveButton, WorkspaceTopbarPreview };
